import React from 'react';
import { useNavigate } from 'react-router-dom';

import { isExternalUrl } from '@/utils/common';

interface AdvertisementCardProps {
  advertisement: Advertisement;
}

export default function AdvertisementCard({ advertisement }: AdvertisementCardProps) {
  const navigate = useNavigate();

  const onClickAdvertisement = () => {
    const { advertisementUrl } = advertisement;
    if (!advertisementUrl) {
      return;
    }

    if (isExternalUrl(advertisementUrl)) {
      window.open(advertisementUrl);
    } else {
      navigate(advertisementUrl);
    }
  };

  return (
    <div className="-mx-4 mt-4 px-5 py-4 bg-gray-2 cursor-pointer" onClick={onClickAdvertisement}>
      <div className="relative">
        <img
          loading="lazy"
          src={advertisement.advertisementImageUrl}
          alt="광고 이미지"
          className="block w-full rounded-lg object-cover bg-gray-3"
          style={{ aspectRatio: '300 / 128' }}
        />
        <span className="absolute top-0 left-0 px-2 py-[3px] rounded-tl-lg rounded-br-lg bg-red text-gray-0 text-[13px] leading-[16px] font-bold">
          광고
        </span>
      </div>
    </div>
  );
}
